// Sequential guard so a slower earlier utilization request cannot overwrite
// the report for the RISE / VISN / specialty the operator selected last.
export function createLatestRequestGuard() {
  let seq = 0;
  return {
    begin() {
      const id = ++seq;
      return () => id === seq;
    },
  };
}
